import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { saveTranscript, updateTranscriptDraft } from "../../services/transcriptService";

const NavigatePrompt = ({ blocker, resetRecording, data,transcript,name }) => {
    const [sendData, setSendData] = useState(null)

    useEffect(()=>{
        const addTranscript = async () => {
            try {
                const draft = localStorage.getItem('draftId')
                if (draft !== null) {
                    try {
                        const time = Date.now() - localStorage.getItem('time')
                        const res = await updateTranscriptDraft({ rawTranscription: JSON.stringify([{ text: transcript, highlight: false }]), id: draft, isTranscriptionComplete: true, duration: time, meetingName: name })

                        if (res.status === 'success') {
                            localStorage.removeItem('draftId');
                            localStorage.removeItem('time')
                            resetRecording()
                            setSendData(null)
                        }
                    } catch (e) {
                        console.log(e)
                        localStorage.removeItem('draftId');
                        localStorage.removeItem('time')
                        resetRecording()
                        setSendData(null)
                    }

                    return;
                }

                const res = await saveTranscript(sendData)
                if (res?.status === "success") {
                    resetRecording()
                    setSendData(null)
                } else
                    throw new Error("Uploaded files data fetch failed");
            } catch (e) {
                console.log(e)
                resetRecording()
                setSendData(null)
            }
        }

        if (sendData !== null)
            addTranscript()
    },[sendData])

    return (
        <>
            <ToastContainer />
            <div className='darkBG' onClick={() => blocker.reset?.()} />
            <div className='centered'>
                <div className='modal'>

                    <div className="loginCardWrapper" style={{ padding: '10px', display: 'flex', flexDirection: 'row', }}>
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                            <div style={{ height: '70px', width: '70px', borderRadius: '50%', border: '1px solid grey', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>  <ion-icon name="warning-outline" style={{ color: 'black', fontSize: 28 }}></ion-icon></div>
                        </div>
                        <div style={{ flex: 4, padding: '10px' }}>
                            <h3 style={{ color: 'black', }}>Warning !</h3>
                            <span style={{ marginTop: 0, color: 'grey', fontWeight: 500, fontSize: '0.8rem' }}>Are you sure you want to leave this page? You have unsaved changes that will be lost if you continue.</span>
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', gap: 10 }}>
                                <button className="deleteBtn" style={{ border: 'none', cursor: 'pointer' }} onClick={() => { blocker.reset?.() }} >Cancel</button>

                                <button className="confirmBtn" style={{ border: 'none', cursor: 'pointer' }} onClick={() => { setSendData(data); blocker.proceed?.(); resetRecording() }} >Save And Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NavigatePrompt;